import { Shield, Clock, Lock } from 'lucide-react'

const signals = [
  { icon: Shield, text: 'Verified plumbers' },
  { icon: Clock,  text: 'Fast response times · 24/7' },
  { icon: Lock,   text: 'Secure payment via Stripe' },
]

export function TrustSignals() {
  return (
    <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center">
      {signals.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-2">
          <Icon className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />
          <span className="text-sm text-gray-500">{text}</span>
        </div>
      ))}
    </div>
  )
}
